import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendAdminInviteEmail } from '../../../actions/emailActions'
import { useDateFormatter } from '../../../hooks/useDateFormatter'
import ActionsMenu from '../../ActionsMenu/ActionsMenu'
import Pagination from '../../Pagination/Pagination'

const UserTable = ({
  users,
  setUserToEdit,
  setShowEditUser,
  setShowDeactivateModal,
  setShowActivateModal,
  setShowDeleteModal,
}) => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)

  const { userInfo } = useSelector((state) => state.userLogin)

  const Row = ({ user }) => {
    const lastActive = useDateFormatter(user.lastActive, 'MM-DD-YYYY')
    const createdAt = useDateFormatter(user.createdAt, 'MM-DD-YYYY')

    const handleEditUser = () => {
      setUserToEdit(user)
      setShowEditUser(true)
    }

    const handleDeactivateUser = () => {
      setShowDeactivateModal(true)
      setUserToEdit(user)
    }

    const handleActivateUser = () => {
      setShowActivateModal(true)
      setUserToEdit(user)
    }

    const handleDeleteUser = () => {
      setShowDeleteModal(true)
      setUserToEdit(user)
    }

    const handleResendInvite = () => {
      dispatch(sendAdminInviteEmail(user))
    }

    const activeOptions = [
      { onClick: handleEditUser, label: 'View/Edit' },
      { onClick: handleDeactivateUser, label: 'Deactivate member' },
    ]

    const deactivatedOptions = [
      { onClick: handleEditUser, label: 'View/Edit' },
      { onClick: handleActivateUser, label: 'Activate member' },
      { onClick: handleDeleteUser, label: 'Delete member' },
    ]

    const invitedOptions = [
      { onClick: handleEditUser, label: 'View/Edit' },
      { onClick: handleResendInvite, label: 'Resend invite' },
      { onClick: handleDeleteUser, label: 'Cancel invite' },
    ]

    const viewOnlyOptions = [{ onClick: handleEditUser, label: 'View details' }]

    return (
      <TableRow>
        <TableCell>
          {user.firstName} {user.lastName}
        </TableCell>
        <TableCell>{user.location}</TableCell>
        <TableCell>{user.role}</TableCell>
        <TableCell>{user.lastActive && lastActive}</TableCell>
        <TableCell>{user.createdAt && createdAt}</TableCell>
        <TableCell>{user.status}</TableCell>
        <TableCell>
          <ActionsMenu
            icon={<MoreVert />}
            options={
              userInfo.role === 'AE'
                ? viewOnlyOptions
                : user.status === 'Active'
                ? activeOptions
                : user.status === 'Deactivated'
                ? deactivatedOptions
                : invitedOptions
            }
          />
        </TableCell>
      </TableRow>
    )
  }

  return (
    <TableContainer>
      <Table stickyHeader aria-label="custom pagination table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Location</TableCell>
            <TableCell>Role</TableCell>
            <TableCell>Last active</TableCell>
            <TableCell>Date added</TableCell>
            <TableCell>Status</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(users.length > 0 && rowsPerPage > 0
            ? users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : users
          ).map((user, index) => (
            <Row key={index} user={user} />
          ))}
        </TableBody>
      </Table>
      <Pagination
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        rows={users}
      />
    </TableContainer>
  )
}

export default UserTable
